import type { ComponentPartState } from '../types';
import { TranslationKeys } from './translationKeys';

export { SectionTypes } from '../constants';

export const REGULAR_STATE: ComponentPartState = {
  id: 'regular',
  label: TranslationKeys.states.regularLabel,
  default: true,
};

export const HOVER_STATE: ComponentPartState = {
  id: 'hover',
  label: TranslationKeys.states.native.hoverLabel,
};

export const DISABLED_STATE: ComponentPartState = {
  id: 'disabled',
  label: TranslationKeys.states.native.disabledLabel,
};

export const DEBOUNCE_TIME = 200;
